import React from 'react';

import { type ObjectTileData } from './types';

export const getObjectTileSizes: (
	objectTile: ObjectTileData,
	isBold?: boolean,
) => {
	label: string;
	element: React.JSX.Element;
	code: string;
}[] = (
	objectTile: ObjectTileData,
	isBold?: boolean,
): {
	label: string;
	element: React.JSX.Element;
	code: string;
}[] => [
	{
		label: 'XSmall (20px)',
		element: <objectTile.component label="" size="xsmall" isBold={isBold} />,
		code: isBold
			? `<${objectTile.componentName} label="" size="xsmall" isBold />`
			: `<${objectTile.componentName} label="" size="xsmall" />`,
	},
	{
		label: 'Small (24px)',
		element: <objectTile.component label="" size="small" isBold={isBold} />,
		code: isBold
			? `<${objectTile.componentName} label="" size="small" isBold />`
			: `<${objectTile.componentName} label="" size="small" />`,
	},
	{
		label: 'Medium (32px)',
		element: <objectTile.component label="" size="medium" isBold={isBold} />,
		code: isBold
			? `<${objectTile.componentName} label="" size="medium" isBold />`
			: `<${objectTile.componentName} label="" size="medium" />`,
	},
	{
		label: 'Large (40px)',
		element: <objectTile.component label="" size="large" isBold={isBold} />,
		code: isBold
			? `<${objectTile.componentName} label="" size="large" isBold />`
			: `<${objectTile.componentName} label="" size="large" />`,
	},
	{
		label: 'XLarge (48px)',
		element: <objectTile.component label="" size="xlarge" isBold={isBold} />,
		code: isBold
			? `<${objectTile.componentName} label="" size="xlarge" isBold />`
			: `<${objectTile.componentName} label="" size="xlarge" />`,
	},
];
